const SERVE_WIDTH_MULTIPLIER = 2;
const GIF_QUALITY = 70;
const MAX_SERVE_WIDTH = 3072;
const RANGES = [
    {
        maxDisplayWidth: 23,
        avifQuality: 45
    },
    {
        maxDisplayWidth: 39,
        avifQuality: 45
    },
    {
        maxDisplayWidth: 63,
        avifQuality: 45
    },
    {
        maxDisplayWidth: 79,
        avifQuality: 45
    },
    {
        maxDisplayWidth: 119,
        avifQuality: 45
    },
    {
        maxDisplayWidth: 159,
        avifQuality: 45
    },
    {
        maxDisplayWidth: 199,
        avifQuality: 45
    },
    {
        maxDisplayWidth: 239,
        avifQuality: 45
    },
    {
        maxDisplayWidth: 255,
        avifQuality: 45
    },
    {
        maxDisplayWidth: 287,
        avifQuality: 45
    },
    {
        maxDisplayWidth: 319,
        avifQuality: 48
    },
    {
        maxDisplayWidth: 383,
        avifQuality: 48
    },
    {
        maxDisplayWidth: 447,
        avifQuality: 50
    },
    {
        maxDisplayWidth: 511,
        avifQuality: 50
    },
    {
        maxDisplayWidth: 575,
        avifQuality: 50
    },
    {
        maxDisplayWidth: 639,
        avifQuality: 52
    },
    {
        maxDisplayWidth: 671,
        avifQuality: 52
    },
    {
        maxDisplayWidth: 767,
        avifQuality: 52
    },
    {
        maxDisplayWidth: 895,
        avifQuality: 55
    },
    {
        maxDisplayWidth: 1023,
        avifQuality: 55
    },
    {
        maxDisplayWidth: 1151,
        avifQuality: 55
    },
    {
        maxDisplayWidth: 1279,
        avifQuality: 55
    },
    {
        maxDisplayWidth: 1535,
        avifQuality: 55
    }
];
const FALLBACK_QUALITY = 55;
const GIF_PATH_RE = /\.gif(\?.*)?$/i;
function isGif(contentfulUrl) {
    return GIF_PATH_RE.test(contentfulUrl);
}
function getOptimizationParams(displayWidth, contentfulUrl) {
    const serveWidth = Math.min(Math.round(displayWidth * SERVE_WIDTH_MULTIPLIER), MAX_SERVE_WIDTH);
    if (isGif(contentfulUrl)) return {
        serveWidth,
        quality: GIF_QUALITY
    };
    for (const range of RANGES)if (displayWidth <= range.maxDisplayWidth) return {
        serveWidth,
        quality: range.avifQuality
    };
    return {
        serveWidth,
        quality: FALLBACK_QUALITY
    };
}
function parseRatio(ratio) {
    if (!ratio || 'auto' === ratio) return;
    const parts = ratio.split('/');
    if (2 !== parts.length) return;
    const w = Number(parts[0]);
    const h = Number(parts[1]);
    if (!Number.isFinite(w) || !Number.isFinite(h) || 0 === h) return;
    return w / h;
}
export { GIF_QUALITY, MAX_SERVE_WIDTH, getOptimizationParams, isGif, parseRatio };
